import axios from 'axios';
import CryptoJS from 'crypto-js';

const SECRET_KEY = '843567893696976453275974432697R634976';

const decryptToken = (encryptedToken) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return null;
  }
};
const axiosInstance = axios.create({
  baseURL: 'http://154.61.173.123:7000',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const encryptedAccessToken = localStorage.getItem('accessToken');
    const encryptedInstantToken = localStorage.getItem('instantToken');

    if (encryptedAccessToken || encryptedInstantToken) {
      const accessToken = decryptToken(
        encryptedAccessToken || encryptedInstantToken
      );
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
